/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
import { buildTask as _buildTask } from "ember-concurrency/async-arrow-runtime";
var _class, _descriptor, _descriptor2, _descriptor3, _ConsultationReportFormComponent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from "@ember/object";
import { service } from "@ember/service";
import { tracked } from "@glimmer/tracking";
import { ForcBaseArgs } from "core/components/forc/abstract/base-component";
import JournalEventBaseComponent from "core/components/forc/abstract/journal-event-based-component";
import JournalEventRetrievalStrategies from "core/components/forc/utils/journal-event-retrieval-strategies";
import ConsultationReportWrittenJournalEvent from "core/models/consultation-report-written-journal-event";
import ConsultationReportWrittenQuestion from "core/models/consultation/consultation-report-written-question";
import tWithDefault from "core/utils/t-with-default";
import { ValidatorMap } from "ember-changeset/types";
import { task } from "ember-concurrency";
import { IntlService } from "ember-intl";
import styles from "./index.module.css";
let ConsultationReportFormComponent = (_class = (_ConsultationReportFormComponent = class ConsultationReportFormComponent extends JournalEventBaseComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "styles", styles);
    _initializerDefineProperty(this, "consultationReportIsDirty", _descriptor, this);
    _initializerDefineProperty(this, "currentQuestions", _descriptor2, this);
    _initializerDefineProperty(this, "intl", _descriptor3, this);
    _defineProperty(this, "journalEventProperties", ["occurredAt", "consultationType", "actionsCarriedOut", "questions"]);
    _defineProperty(this, "retrieveJournalEvent", JournalEventRetrievalStrategies.sourceJournalEvent);
    _defineProperty(this, "autoSaveDraft", true);
    _defineProperty(this, "generatePdf", _buildTask(() => ({
      context: this,
      generator: function* (event) {
        // event target is the download icon, to get the full page HTML, we must go back to the offsetParent
        const htmlToPrint = event?.target?.offsetParent?.cloneNode(true);
        const opt = {
          margin: [5, 10, 5, 10],
          filename: `Compte rendu ${this.changeset.consultationType} ${this.patient.fullName}`,
          pagebreak: {
            after: [".breaking-page"]
          }
        };
        this.replaceInputByDiv(htmlToPrint.querySelector("[data-test-input] input"));

        //workaround to fix the diplaying of texteArea
        //cf https://github.com/niklasvh/html2canvas/issues/2008#issuecomment-990597427
        let heightOfPage = 154.4 + (event?.target).offsetParent?.querySelector(".ui.header")?.offsetHeight;
        const maxHeightOfPage = 760; //in px

        // TEXTAREA
        Array.from(htmlToPrint?.querySelectorAll("textarea")).forEach((textarea, index) => {
          const div = document.createElement("div");
          div.innerHTML = textarea.value.replace(/\n/g, "<br>");
          div.style.border = "1px solid rgba(34, 36, 38, 0.15)";
          div.style.borderRadius = "0.28571429rem";
          div.style.padding = "0.78571429em 1em";
          div.style.marginTop = "0.5em";
          div.style.color = "#1c1d1e";
          textarea?.parentElement?.append(div);
          textarea.style.display = "none";

          //get the total height of the textArea parent
          //it's needed to add the element to the dom to get the height
          //we take a clone of the element because if not it's removed from htmlToPrint when we put it in document.body
          const clone = textarea?.parentElement?.cloneNode(true);
          clone.style.visibility = "hidden";
          if (clone) {
            document.body.appendChild(clone);
          }
          const fieldHeight = clone.offsetHeight + 0;
          heightOfPage += fieldHeight;
          document.body.removeChild(clone);
          clone.style.visibility = "visible";

          //add breaking page to avoid cut paragraph
          if (heightOfPage >= maxHeightOfPage) {
            htmlToPrint?.querySelectorAll("textarea")[index - 1].parentElement?.classList.add("breaking-page");
            heightOfPage = fieldHeight;
          }
        });

        //remove the footer buttons (retour and sauvegarder)
        htmlToPrint.removeChild(htmlToPrint.children[htmlToPrint.children.length - 1]);
        const html2pdf = (yield import("html2pdf.js")).default;
        html2pdf(htmlToPrint, opt);
      }
    }), null, "generatePdf", null));
  }
  get changeset() {
    const changeset = super.changeset;
    if (this.args.resetDraft && this.draft) {
      this.draft.clear();
    }
    return changeset;
  }
  get consultationLabel() {
    const consultationType = this.changeset.get("consultationType");
    return tWithDefault(this.intl, `consultation-history.${consultationType}`, consultationType);
  }
  get comesFromDashboard() {
    const consultationType = this.changeset.get("consultationType");
    return !!this.intl.lookup(`consultation-history.${consultationType}`, "fr-fr", {
      resilient: true
    });
  }
  get validations() {
    return this.journalEventClass.validations(this.intl);
  }
  retrieveModel() {
    const model = super.retrieveModel();
    if (this.isNewMode) {
      model.questions = ConsultationReportWrittenJournalEvent.getQuestions(this.args.consultationType);
      model.occurredAt = new Date();
      model.consultationType = this.args.consultationType;
    }
    return model;
  }
  setCurrentQuestions(questions) {
    this.currentQuestions = questions;
  }
  get questions() {
    // We only provide the questions that are in relation with
    // the current consultationType
    const currentQuestionsInChangeset = this.changeset.get("questions");
    return this.currentQuestions?.map(currentQuestion => {
      // If the question exists in the changeset (i.e. in the draft)
      // We provide it
      const alreadyExistingQuestionInChangeset = currentQuestionsInChangeset.find(q => q.key == currentQuestion.key);
      if (alreadyExistingQuestionInChangeset) {
        return alreadyExistingQuestionInChangeset;
      }
      // Otherwise, we provide the default question
      return currentQuestion;
    });
  }

  // As we store every questions, even when changing consultation type
  // We just want the ones we are currently editing
  async save() {
    const questionsChangeset = this.changeset.get("questions");
    const curatedQuestionsChangeset = questionsChangeset.filter(question => this.currentQuestions.map(q => q.key).includes(question.key));
    this.changeset.set("questions", curatedQuestionsChangeset);
    return await super.save();
  }
  updateQuestion() {
    this.consultationReportIsDirty = true;
  }
  get isDirty() {
    return this.consultationReportIsDirty ? true : super.isDirty;
  }
  replaceInputByDiv(input) {
    const dateDiv = document.createElement("div");
    dateDiv.innerText = input.value;
    dateDiv.style.border = "1px solid rgba(34, 36, 38, 0.15)";
    dateDiv.style.borderRadius = "0.28571429rem";
    dateDiv.style.padding = "0.5em 1em";
    input?.parentNode?.replaceChild(dateDiv, input);
  }
}, _defineProperty(_ConsultationReportFormComponent, "fullComponentId", "consultation/report-form"), _defineProperty(_ConsultationReportFormComponent, "forcDisplayName", "Compte rendu de consultation"), _defineProperty(_ConsultationReportFormComponent, "journalEventClass", ConsultationReportWrittenJournalEvent), _ConsultationReportFormComponent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "consultationReportIsDirty", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentQuestions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "setCurrentQuestions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setCurrentQuestions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "updateQuestion", [action], Object.getOwnPropertyDescriptor(_class.prototype, "updateQuestion"), _class.prototype), _class);
export { ConsultationReportFormComponent as default };